import { useCallback, useEffect, useRef } from 'react';
export function useDialog(callback) {
    const ref = useRef(null);
    const onClick = useCallback((event) => {
        const dialog = ref.current;
        if (!dialog)
            return;
        if (event.target === dialog)
            callback();
    }, [callback]);
    const onCancel = useCallback((event) => {
        event.preventDefault();
        callback();
    }, [callback]);
    useEffect(() => {
        const dialog = ref.current;
        if (dialog) {
            if (typeof dialog.showModal === 'function') {
                dialog.showModal();
            }
            dialog.addEventListener('click', onClick);
            dialog.addEventListener('cancel', onCancel);
            return () => {
                dialog.removeEventListener('click', onClick);
                dialog.removeEventListener('cancel', onCancel);
            };
        }
    }, [onClick, onCancel]);
    return { ref };
}
